import React from "react";
import "../styles/Pricing.css";
import { FaStar } from "react-icons/fa";

const planos = [
  {
    nome: "Free Trial",
    preco: "R$ 0,00",
    descricao: "1 mês de utilização completa do Arc totalmente de graça!",
    destaque: false,
    recomendado: false,
  },
  {
    nome: "Plano Mensal",
    preco: "R$ 97,00",
    descricao:
      "1 mês de utilização completa do Arc + 1 mês grátis na contratação inicial da conta",
    destaque: false,
    recomendado: false,
  },
  {
    nome: "Plano Trimestral",
    preco: "R$ 279,00",
    descricao:
      "3 meses de utilização completa do Arc + 1 mês grátis na contratação inicial da conta",
    destaque: true,
    recomendado: true,
  },
  {
    nome: "Plano Semestral",
    preco: "R$ 549,00",
    descricao:
      "6 meses de utilização completa do Arc + 1 mês grátis na contratação inicial da conta",
    destaque: false,
    recomendado: false,
  },
];

function Pricing() {
  return (
    <section className="pricing-section" id="pricing">
      <h2 className="pricing-title">Escolha seu plano</h2>
      <div className="pricing-container">
        {planos.map((plano, index) => (
          <div
            key={index}
            className={`pricing-card ${plano.recomendado ? "recomendado" : ""}`}
          >
            {plano.recomendado && (
              <div className="badgePricing">
                <FaStar style={{color: "#fac852"}}/> RECOMENDADO
              </div>
            )}
            <div className="pricing-header">
              <h3>{plano.nome}</h3>
              <p className="preco">{plano.preco}</p>
            </div>
            <p className="descricao">{plano.descricao}</p>
            <button className="btn-assinar">Assinar plano</button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Pricing;
